import { createContext } from 'react';

export type PanelActions = {
  toDetail: () => void;
  toList: () => void;
  toSplit: () => void;
};

export type SessionsPanelContextValue = {
  sessionId: string;
  /** Sticky last non-empty `sessionId`; survives back-nav clearing the URL id. */
  lastViewedSessionId: string;
  isLeftCollapsed: boolean;
  isEhrLaunch: boolean;
  /** False when the container can't fit both panels → render a single pane. */
  canFitSplit: boolean;
  /** Held from a fullscreen-hide click until the collapse settles; suppresses the split (sand) chrome. */
  isFullscreenDetailCollapse: boolean;
  panelActions: PanelActions;
};

export const SessionsPanelContext = createContext<SessionsPanelContextValue | null>(null);
